<template>
  <div class="adminEditBox">
    <Form ref="editForm" :label-width="120" :model="formCustom" :rules="editRules" inline>
      <Form-item label="用户账号名称：" prop="nikeName">
        <Input v-model="formCustom.nikeName" :maxlength="50" clearable placeholder="请输入"
               style="width: 240px"></Input>
      </Form-item>
      <Form-item label="关联角色：" prop="roleName">
        <Input v-model="formCustom.roleName" disabled style="width: 240px"></Input>
      </Form-item>
      <br>
      <FormItem label="联系电话：" prop="telephone">
        <Input v-model="formCustom.telephone" disabled style="width: 240px"></Input>
      </FormItem>
      <FormItem label="账号编码：" prop="adminCode">
        <Input v-model="formCustom.adminCode" disabled style="width: 240px"></Input>
      </FormItem>
    </Form>
    <div class="footerButton">
      <Button type="default" @click="handleBack('add')">返回</Button>
      <Button :loading="editLoading" style="margin-left: 10px" type="primary" @click="handleCommit('editForm')">
        <span v-if="!editLoading">提交</span>
        <span v-else>提交中</span>
      </Button>
    </div>
  </div>
</template>

<script>
import {adminDetail, adminEdit} from '@/api/authority'

export default {
  name: 'adminEdit',
  data() {
    return {
      adminId: '', // 获取编辑数据的id
      editLoading: false,
      formCustom: {
        nikeName: '',
        adminCode: '',
        roleId: '',
        telephone: ''
      },
      editRules: {
        nikeName: [{required: true, message: '用户账号名称不能为空', trigger: 'blur'}]
      }
    }
  },
  mounted() {
    this.adminId = this.$route.query.adminId
    this.init()
  },
  methods: {
    // 初始化
    init() {
      // 回显数据
      adminDetail(this.adminId).then((res) => {
        this.formCustom = res.data.data.data
      })
    },
    // 返回
    handleBack() {
      this.$router.push(
        {
          path: '/authority/admin',
          query: {
            current: this.$route.query.current,
            size: this.$route.query.size,
            nikeName: this.$route.query.nikeName,
            adminCode: this.$route.query.adminCode,
            status: this.$route.query.status
          }
        }
      )
    },
    // 提交
    handleCommit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.editLoading = true
          adminEdit({
            adminId: this.adminId,
            orgId: 1,
            nikeName: this.formCustom.nikeName,
            adminCode: this.formCustom.adminCode,
            telephone: this.formCustom.telephone
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.editLoading = false
            } else {
              this.$Message.success(response.data.msg)
              this.editLoading = false
              this.$router.push({name: 'admin'})
            }
          }).catch(() => {
            this.editLoading = false
          })
        }
      })
    }
  }
}
</script>
